import { MouseEventHandler } from "react";
import { useDispatch } from "react-redux";

import { CaseDocumentAdmin } from "pwapi";

import { updateAdminDocument } from "shared/actions/admin/adminDocumentsActions";
import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "store/hooks";

import DocumentsForm from "./DocumentsForm";
import { shallowDocumentComparison } from "./editDocumentsFormUtils";

type EditDocumentsFormProps = {
  document: CaseDocumentAdmin;
  adminCase?: CaseAdminDetail;
  onDelete: Function;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

const EditDocumentsForm = ({
  document,
  adminCase,
  onDelete,
  onClose,
}: EditDocumentsFormProps) => {
  const dispatch = useDispatch();
  const useMergeCaseReportWorkflow = useAppSelector((state) =>
    selectFeatureFlag(state, "useMergeCaseReportWorkflow")
  );

  const handleOnSubmit = (updatedValues: any) => {
    const values = shallowDocumentComparison(
      document,
      updatedValues,
      useMergeCaseReportWorkflow
    ) as {
      [key: string]: any;
    };
    const submitForm = new FormData();
    submitForm.append("id", `${document.id}`);

    Object.keys(values)
      .filter((k) => k !== "file" && k !== "case")
      .forEach((key) => {
        submitForm.append(key, `${values[key]}`);
      });

    if (updatedValues.file) {
      submitForm.append("file_uploaded", updatedValues.file);
    }

    dispatch(updateAdminDocument(submitForm, onClose));
  };

  const order = document.lab_order_id
    ? adminCase?.lab_orders?.find((o) => o.id === document.lab_order_id)
    : undefined;

  return (
    <DocumentsForm
      document={{ ...document, case: adminCase }}
      order={order}
      onSubmit={handleOnSubmit}
      onDelete={onDelete}
      onClose={onClose}
      isUploading={document.status === CaseDocumentAdmin.status.PENDING}
    />
  );
};

export default EditDocumentsForm;
